export default __webpack_public_path__ + "static/media/4700@2x.0e243a57.png";